export const GLOBAL_TIMEOUT = 20000;
const DEFAULT_TIMEOUT = GLOBAL_TIMEOUT;

export default (ms = DEFAULT_TIMEOUT) =>
  new Promise(resolve => setTimeout(resolve, ms));

/**
 * Waits for `promise`, but for no longer than `ms`: resolves to its result, or
 * to undefined once `ms` has passed, whichever comes first. A rejection is
 * passed on. The timer is cleared either way; the promise itself carries on.
 */
export async function waitAtMost(promise, ms) {
  let timer;
  try {
    return await Promise.race([
      promise,
      new Promise(resolve => {
        timer = setTimeout(resolve, ms);
      }),
    ]);
  } finally {
    clearTimeout(timer);
  }
}
